// Import content data from JavaScript module
import { contentData } from './contentData';

/**
 * Get content from JSON file
 * This replaces environment variables with JSON data source
 */
export const getContentData = () => {
  return contentData;
};

/**
 * Get specific content value by key
 * Supports nested keys using dot notation (e.g., 'tech.0.title')
 */
export const getContent = (key, defaultValue = '') => {
  const keys = key.split('.');
  let value = contentData;
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      return defaultValue;
    }
  }
  
  return value || defaultValue;
};

/**
 * Get tech items in specified order
 */
export const getTechData = () => {
  const sequence = contentData.techSeq.split(',').map(Number);
  const techItems = contentData.tech;
  
  return sequence
    .map(id => techItems.find(item => item.id === id.toString()))
    .filter(Boolean);
};

/**
 * Get work items in their original order
 */
export const getWorksData = () => {
  return contentData.works;
};

/**
 * Get work item by ID
 */
export const getWorkById = (id) => {
  return contentData.works.find(item => item.id === id);
};
